import React from "react";

const HomePageNewsSkeleton: React.FC = () => {
  return (
    <>
      <div className="p-9 pt-0 max-md:px-0">
        <div className="flex items-center justify-center max-sm:flex-wrap max-sm:gap-3">
          <div className="skeleton w-[300px] h-[440px] !rounded-none rotate-[5deg] max-sm:rotate-0"></div>
          <div className="skeleton w-[300px] h-[440px] !rounded-none -rotate-[5deg] max-sm:rotate-0"></div>
        </div>
        <div className="skeleton w-80 h-12 text-4xl ms-auto block uppercase underline mt-10 py-4 px-9 duration-150 hover:scale-95"></div>
      </div>
    </>
  );
};

export default HomePageNewsSkeleton;
